import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { IconRaiseHand } from '../../../base/icons/svg';
import { getParticipantById, hasRaisedHand } from '../../../base/participants/functions';
import BaseIndicator from '../../../base/react/components/web/BaseIndicator';
import { isMobileBrowser } from "../../../base/environment/utils";
const useStyles = makeStyles()(theme => {
    return {
        raisedHandIndicator: {
            backgroundColor: 'rgba(255, 214, 56, 1)',
            padding: '4px',
            zIndex: 3,
            display: 'inline-block',
            borderRadius: '4px',
            boxSizing: 'border-box',
            '&.is-mobile': {
                borderRadius: '6px',
            }
        }
    };
});
/**
 * Thumbnail badge showing that the participant would like to speak.
 *
 * @returns {ReactElement}
 */
const RaisedHandIndicator = ({ iconSize, participantId, tooltipPosition }) => {
    const participant = useSelector((state) => getParticipantById(state, participantId));
    const _raisedHand = hasRaisedHand(participant);
    const { classes: styles, cx } = useStyles();
    if (!_raisedHand) {
        return null;
    }
    return (React.createElement("div", { className: cx(styles.raisedHandIndicator, isMobileBrowser() && 'is-mobile') },
        React.createElement(BaseIndicator, { icon: IconRaiseHand, iconColor: 'rgba(0, 0, 0, 1)', iconSize: `${iconSize}px`, tooltipKey: 'raisedHand', tooltipPosition: tooltipPosition })));
};
export default RaisedHandIndicator;
